import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAgency } from '../lib/AgencyContext';
import { useI18n } from '../lib/i18n';
import { formatRSD } from '../lib/helpers';

// Meseci izabrane godine (za tekuću godinu samo do tekućeg meseca), najnoviji prvi
function monthsOfYear(year) {
  const now = new Date();
  const last = year === now.getFullYear() ? now.getMonth() + 1 : 12;
  const out = [];
  for (let m = last; m >= 1; m--) out.push({ year, month: m });
  return out;
}

export default function Taxes() {
  const { activeAgencyId, year: selectedYear } = useAgency();
  const { t } = useI18n();
  const [payments, setPayments] = useState({});
  const [loading, setLoading] = useState(true);
  const months = monthsOfYear(selectedYear);
  const MONTH_NAMES = t('monthNames');

  useEffect(() => {
    if (!activeAgencyId) return;
    supabase.from('tax_payments').select('*').eq('agency_id', activeAgencyId).then(({ data }) => {
      const map = {};
      (data || []).forEach((p) => { map[`${p.period_year}-${p.period_month}`] = p; });
      setPayments(map);
      setLoading(false);
    });
  }, [activeAgencyId]);

  const togglePaid = async (year, month) => {
    const key = `${year}-${month}`;
    const existing = payments[key];
    const newPaid = !existing?.paid;

    const { data, error } = await supabase
      .from('tax_payments')
      .upsert({
        agency_id: activeAgencyId,
        period_year: year,
        period_month: month,
        paid: newPaid,
        paid_at: newPaid ? new Date().toISOString() : null,
        amount: existing?.amount || 29428,
      }, { onConflict: 'agency_id,period_month,period_year' })
      .select()
      .single();

    if (!error && data) {
      setPayments((prev) => ({ ...prev, [key]: data }));
    }
  };

  if (loading) return <div style={styles.loading}>{t('loadingGeneric')}</div>;

  return (
    <div>
      <h1 style={styles.heading}>{t('taxesHeading')} {selectedYear}</h1>
      <p style={styles.sub}>{t('taxesSub')}</p>

      <div style={styles.list}>
        {months.map(({ year, month }) => {
          const key = `${year}-${month}`;
          const paid = payments[key]?.paid;
          return (
            <div key={key} style={styles.row}>
              <div style={styles.rowMain}>
                <div style={styles.rowTitle}>{MONTH_NAMES[month - 1]} {year}.</div>
                <div style={styles.rowAmount}>{formatRSD(payments[key]?.amount || 29428)}</div>
              </div>
              <button
                onClick={() => togglePaid(year, month)}
                style={{ ...styles.toggleBtn, ...(paid ? styles.toggleBtnPaid : {}) }}
              >
                {paid ? t('paidShort') : t('markPaid')}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const styles = {
  loading: { padding: 40, textAlign: 'center', color: 'var(--ink-500)' },
  heading: { fontSize: 22, marginBottom: 8 },
  sub: { fontSize: 13, color: 'var(--ink-500)', marginBottom: 18 },
  list: { display: 'flex', flexDirection: 'column', gap: 8 },
  row: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'var(--surface)',
    border: '1px solid var(--line)', borderRadius: 10, padding: '14px 16px', flexWrap: 'wrap', gap: 10,
  },
  rowMain: {},
  rowTitle: { fontWeight: 600, fontSize: 14, color: 'var(--ink-900)' },
  rowAmount: { fontSize: 13, color: 'var(--ink-500)' },
  toggleBtn: { border: '1px solid var(--line)', background: 'var(--surface)', borderRadius: 10, padding: '9px 14px', fontWeight: 600, fontSize: 13, color: 'var(--ink-700)' },
  toggleBtnPaid: { background: 'var(--forest-100)', borderColor: 'var(--forest-500)', color: 'var(--forest-600)' },
};
